import { useEffect, useState } from 'react'
import Heading from '../../component/Heading/Heading'
import TableComponent from '../../component/Table/TableComponent';
import CommonButton from "../../component/button/Button";
import { Autocomplete, Box, TableCell, TableRow, TextField, Typography } from '@mui/material';
import { clientPaymentStatus, getPaymentStatusList } from '../../services/admin-services/clientServices';
import { getAllCustomerCompany } from '../../services/customer-services/customerCompanyService';
import Toast from '../../component/toastify/Index';
import { changeDateFormate, changeDateFormatWithTime } from '../../helper/changeDateFormate';
import CommonModal from "../../component/model/ModelComponent";
import { useTranslation } from 'react-i18next';
import { statusColor } from '../../content/content';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CommonGradientSwitch from '../../component/switch/CommonSwitch';
import "../../styles/pages/client/clientList.scss";
import "../../styles/pages/client/clientPaymentStatus.scss";
import { Grid } from '@mui/material';

const ClientsPaymentStatus = () => {
    const { t } = useTranslation();
    const [paymentStatus, setPaymentStatus] = useState([]);
    const [pageNo, setPageNo] = useState(1);
    const [perPage, setPerPage] = useState(25);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isConfirmPayment, setIsConfirmPayment] = useState(false);
    const [paymentDetail, setPaymentDetail] = useState({});
    const [company, setCompany] = useState([]);
    const [selectCompany, setSelectCompany] = useState("");
    const [archive, setArchive] = useState(false);
    const [disabled, setDisabled] = useState(false)

    const getAllClientRequestList = async (payload) => {
        const response = await getPaymentStatusList(payload);
        setPaymentStatus(response?.client)
        setTotalRecords(response?.totalRecords ? response?.totalRecords : 0)
        setDisabled(response?.isDisabled)
    }

    const getCompanyList = async () => {
        const response = await getAllCustomerCompany();
        if (response?.isSuccess) {
            const { companyList } = response
            const allCompanyList = companyList.map((i) => ({ label: i.name, value: i._id }))
            setCompany(allCompanyList)
        }
    }

    useEffect(() => {
        getAllClientRequestList({ company: selectCompany, archive, pageNo, perPage });
    }, [selectCompany, archive, pageNo, perPage]);

    useEffect(() => {
        getCompanyList();
    }, []);

    const handleApprove = async (id, confirm) => {
        const response = await clientPaymentStatus(id, confirm);
        if (response?.isSuccess) {
            Toast(response?.message, "success");
            getAllClientRequestList();
        }
        setIsModalOpen(false)
    }

    const InitialPaymentStatusDate = (planName, dateName) => {
        const today = new Date();
        let resultDate;

        if (planName === "Monthly") {
            if (dateName === "startDate") {
                resultDate = today;
            } else if (dateName === "endDate") {
                resultDate = new Date();
                resultDate.setDate(today.getDate() + 365); // Add 365 days to today
            } else if (dateName === "nextBillingDate") {
                resultDate = new Date();
                resultDate.setDate(today.getDate() + 30); // Add 30 days to today
            } else {
                throw new Error("Invalid dateName");
            }
        } else {
            if (dateName === "startDate") {
                resultDate = today;
            } else if (dateName === "endDate") {
                resultDate = new Date();
                resultDate.setDate(today.getDate() + 365); // Add 365 days to today
            } else if (dateName === "nextBillingDate") {
                resultDate = new Date();
                resultDate.setDate(today.getDate() + 365); // Add 365 days to today
            } else {
                throw new Error("Invalid dateName");
            }
        }

        return changeDateFormate(resultDate);
    };

    const openModal = (confirm, paymentStatus) => {
        setIsModalOpen(true);
        setIsConfirmPayment(confirm);
        setPaymentDetail(paymentStatus);
    };

    const getDynamicColumns = (data) => {
        let baseColumns = [
            { field: 'firstName', headerName: 'First Name', sortable: true, translationKey: 'common_label_first_name' },
            { field: 'lastName', headerName: 'Last Name', sortable: true, translationKey: 'common_label_last_name' },
            { field: 'email', headerName: 'Email', sortable: true, translationKey: 'common_label_email' },
            { field: 'name', headerName: 'Company Name', sortable: true, translationKey: 'common_label_company_name' },
            { field: 'mobileNumber', headerName: 'Mobile Number', translationKey: 'common_label_mobile_number' },
            { field: 'referenceCode', headerName: 'Reference Code', translationKey: 'client_list_reference_code' },
            { field: 'subscriptionNumber', headerName: 'Subscription Number', translationKey: 'payment_history_subscription_number' },
            { field: 'planFrequency', headerName: 'Subscription', sortable: true, translationKey: 'client_list_subscription' },
            { field: 'subscriptionStartDate', headerName: 'Start Date', sortable: true, translationKey: 'client_list_start_date' },
            { field: 'subscriptionEndDate', headerName: 'End Date', sortable: true, translationKey: 'client_list_end_date' },
            { field: 'nextPaymentDate', headerName: 'Next Billing Date', sortable: true, translationKey: 'payment_status_next_billing_date' },
            { field: 'action', headerName: 'Action', translationKey: 'client_list_action' },
        ];

        // Check if any row has billingDetail
        if (data?.some(row => row?.billingDetail?.length > 0) || archive || selectCompany) {
            // Add "Paid Date" column
            baseColumns.push({
                field: 'paidDate',
                headerName: 'Paid Date',
                sortable: true,
                translationKey: 'Paid Date'
            });

            // Remove "Action" and "Next Billing Date" columns
            baseColumns = baseColumns.filter(col => col.field !== 'action' && col.field !== 'nextPaymentDate');
        }

        return baseColumns;
    };

    return (
        <div className="users clientList">
            <div className="user-heading">
                <Grid container rowSpacing={2} columnSpacing={3} sx={{ alignItems: 'center' }}>
                    <Grid item size={{ xs: 12, md: 12, xl: 8 }} className="generally-col-one">
                        <Grid container rowSpacing={2} columnSpacing={3} sx={{ alignItems: 'center' }}>
                            <Grid item size={{ xs: 12, lg: 'auto' }} className="generally-col-one">
                                <Heading text={t('module_payment_status')} className="user-heading" />
                            </Grid>
                            <Grid item size={{ xs: 12, lg: 6, xl: 8 }} className="generally-col-one">
                                <Grid container rowSpacing={2} columnSpacing={3}>
                                    <Grid item size={{ xs: 12, md: 'auto' }}>
                                        <CommonGradientSwitch
                                            label={<span style={{ fontFamily: 'Poppins' }}>{t('client_list_archive')}</span>}
                                            checked={archive}
                                            onChange={(e) => setArchive(e.target.checked)}
                                        />
                                    </Grid>
                                    <Grid item size={{ xs: 12, md: 6 }}>
                                        <Autocomplete
                                            onChange={(e, newValue) => setSelectCompany(newValue?.value)}
                                            options={company}
                                            popupIcon={<ExpandMoreIcon sx={{ fontSize: "30px", color: "#33333399", "& .MuiIconButton-root": { backgroundColor: 'transparent' } }} />}
                                            value={company?.find(opt => opt.value === selectCompany) || ""}
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: "10px",
                                                    border: "1px solid rgba(227, 227, 227, 0.57)"
                                                },
                                            }}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    placeholder={t('client_list_placeholder_company')}
                                                    sx={{
                                                        "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
                                                            padding: 0
                                                        }
                                                    }} />}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 12, xl: 4 }} className="generally-col-one" display={'flex'} justifyContent={{ xl: 'end' }}>
                        <Box display="flex" gap="8px" flexDirection={{ xs: 'column' }}>
                            {
                                statusColor.map((color, index) => (
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        gap="8px"
                                        key={index}
                                    >
                                        <Box
                                            sx={{
                                                width: 8,
                                                height: 8,
                                                borderRadius: '50%',
                                                backgroundColor: color.color,
                                            }}
                                        />
                                        <Typography fontFamily={'Poppins'}>{color.description}</Typography>
                                    </Box>
                                ))
                            }
                        </Box>
                    </Grid>
                </Grid>
            </div>
            <div className='payment-status'>
                <TableComponent
                    data={paymentStatus}
                    setPageNo={setPageNo}
                    pageNo={pageNo}
                    perPage={perPage}
                    setPerPage={setPerPage}
                    totalRecords={totalRecords}
                    columns={getDynamicColumns(paymentStatus)}
                    setData={setPaymentStatus}
                    className={'payment-table-max-height'}
                >
                    {paymentStatus?.map((row, rowIndex) => {
                        const currentDate = new Date();
                        const nextPaymentDate = new Date(row?.nextPaymentDate);

                        const daysDifference = (nextPaymentDate - currentDate) / (1000 * 60 * 60 * 24);

                        let statusColor;
                        if (nextPaymentDate < currentDate) {
                            statusColor = "red"; // Overdue
                        } else if (daysDifference <= 7) {
                            statusColor = "orange"; // Reminder (within 7 days ahead)
                        } else {
                            statusColor = "green"; // More than 7 days away
                        }
                        return (
                            (
                                row?.billingDetail?.length > 0 ? <>
                                    {
                                        row?.billingDetail.map((filterRow) => {
                                            return (
                                                <TableRow key={rowIndex}>
                                                    <TableCell>
                                                        <Box
                                                            display="flex"
                                                            alignItems="center"
                                                            gap="8px"
                                                        >
                                                            <span>{row.client.firstName}</span>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>{row.client.lastName}</TableCell>
                                                    <TableCell>{row.client.email}</TableCell>
                                                    <TableCell>{row.name}</TableCell>
                                                    <TableCell>{row.client.mobileNumber}</TableCell>
                                                    <TableCell>{row.client.referenceCode}</TableCell>
                                                    <TableCell>{filterRow?.subscriptionNumber}</TableCell>
                                                    <TableCell>{filterRow?.planFrequency}</TableCell>
                                                    <TableCell>{changeDateFormate(filterRow?.subscriptionStartDate)}</TableCell>
                                                    <TableCell>{changeDateFormate(filterRow?.subscriptionEndDate)}</TableCell>
                                                    <TableCell>{filterRow?.planFrequency === "Free Trial" ? "-" : changeDateFormatWithTime(filterRow?.confirmedAt)}</TableCell>
                                                </TableRow>
                                            )
                                        })
                                    }
                                </> : (
                                    <TableRow key={rowIndex}>
                                        <TableCell>
                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                gap="8px"
                                            >
                                                {
                                                    (!selectCompany) && <Box
                                                        sx={{
                                                            width: 8,
                                                            height: 8,
                                                            borderRadius: '50%',
                                                            backgroundColor: statusColor,
                                                        }}
                                                    />
                                                }
                                                <span>{row.client.firstName}</span>
                                            </Box>
                                        </TableCell>
                                        <TableCell>{row.client.lastName}</TableCell>
                                        <TableCell>{row.client.email}</TableCell>
                                        <TableCell>{row.name}</TableCell>
                                        <TableCell>{row.client.mobileNumber}</TableCell>
                                        <TableCell>{row.client.referenceCode}</TableCell>
                                        <TableCell>{row.billingDetail?.subscriptionNumber}</TableCell>
                                        <TableCell>{row.billingDetail?.planFrequency}</TableCell>
                                        <TableCell>{row.subscriptionMetaData?.planFrequency !== "Free Trial" ? changeDateFormate(row.subscriptionStartDate) : InitialPaymentStatusDate(row.billingDetail?.planFrequency, "startDate")}</TableCell>
                                        <TableCell>{row.subscriptionMetaData?.planFrequency !== "Free Trial" ? changeDateFormate(row.subscriptionEndDate) : InitialPaymentStatusDate(row.billingDetail?.planFrequency, "endDate")}</TableCell>
                                        {
                                            (!selectCompany)
                                                ? <TableCell>{row.billingDetail?.planFrequency === "Free Trial" ? "-" : row.subscriptionMetaData?.planFrequency !== "Free Trial" ? changeDateFormate(row.nextPaymentDate) : InitialPaymentStatusDate(row.billingDetail?.planFrequency, "nextBillingDate")}</TableCell>
                                                : <TableCell>{row.billingDetail?.planFrequency === "Free Trial" ? "-" : changeDateFormatWithTime(row?.billingDetail?.confirmedAt)}</TableCell>
                                        }
                                        {
                                            (!selectCompany) && <TableCell className='client-paymnet-confirm-btn'>
                                                <Typography sx={{ display: "flex", alignItems: "centere", gap: 2 }} >
                                                    <CommonButton
                                                        text={t('payment_status_confirm')}
                                                        onClick={() => openModal(true, row)}
                                                        disabled={disabled}
                                                    />
                                                    <CommonButton
                                                        text={t('approval_list_decline')}
                                                        bgColor="linear-gradient(90deg, #E14A4A 0%, #FF4848 100%)"
                                                        onClick={() => openModal(false, row)}
                                                        disabled={disabled}
                                                    />
                                                </Typography>
                                            </TableCell>
                                        }
                                        <div>
                                            <CommonModal
                                                open={isModalOpen}
                                                onClose={() => setIsModalOpen(false)}
                                                title={isConfirmPayment ? `${t('payment_status_confirm')} ${t('module_payment_status')}` : `${t('approval_list_decline')} ${t('module_payment_status')}`}
                                                className="model-title clientList"
                                            >
                                                <Typography
                                                    className='client-model'
                                                    sx={{
                                                        border: "1px solid #E3E3E3",
                                                        padding: "20px",
                                                        borderRadius: "10px",
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontWeight: "500",
                                                            color: "#333",
                                                            margin: "20px",
                                                            fontFamily: "Poppins",
                                                            textAlign: "center"
                                                        }}
                                                    >
                                                        {isConfirmPayment
                                                            ? `Are you sure? Payment is confirmed. Next billing date is:`
                                                            : `Are you sure? Payment is not confirmed. Next billing date will be:`} {""}
                                                        <strong>
                                                            {
                                                                paymentDetail.subscriptionMetaData?.planFrequency !== "Free Trial"
                                                                    ? changeDateFormate(paymentDetail.nextPaymentDate)
                                                                    : InitialPaymentStatusDate(paymentDetail.billingDetail?.planFrequency, "nextBillingDate")
                                                            }
                                                        </strong>
                                                    </Typography>
                                                    <Typography className="model-action-btn">
                                                        <CommonButton
                                                            text={t('payment_status_cancel')}
                                                            className="invitation-btn"
                                                            bgColor="linear-gradient(90deg, #E14A4A 0%, #FF4848 100%);"
                                                            onClick={() => setIsModalOpen(false)}
                                                        />
                                                        <CommonButton
                                                            text={t('payment_status_confirm')}
                                                            className="add-user-btn"
                                                            onClick={() => handleApprove(paymentDetail.client._id, isConfirmPayment ? true : false)}
                                                        />
                                                    </Typography>
                                                </Typography>
                                            </CommonModal>
                                        </div>

                                    </TableRow>
                                )
                            )
                        )
                    })}
                </TableComponent>
            </div>
        </div >
    );
};

export default ClientsPaymentStatus;